






























import Vue from 'vue'
import { ProductionPlanExcelServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
import { ProcessExcelServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { exportProductionPlanTemplate, exportIncomingPlanTemplate } from '@/api/api'
import { downloadFile } from '../../../../utils'
const ppesp = new ProductionPlanExcelServiceProxy()
const pesp = new ProcessExcelServiceProxy()

const P = 'p',
  M = 'm'

export default Vue.extend({
  props: ['filename'],
  data() {
    return {
      visible: false,
      loading: {
        submit: false,
        download: false,
      },
      fileList: [],
      typeId: this.$route.path[this.$route.path.length - 1],
      type: P,
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (!val) {
          this.fileList = []
        }
      },
    },
  },
  methods: {
    openModal({ key }) {
      this.type = key
      this.visible = true
    },
    async download() {
      this.loading.download = true
      try {
        let res
        if (this.type === P) {
          res = await exportProductionPlanTemplate(this.typeId)
          downloadFile(res, '生产计划模板.xlsx')
        }
        if (this.type === M) {
          res = await exportIncomingPlanTemplate(this.typeId)
          downloadFile(res, '来料计划模板.xlsx')
        }
      } finally {
        this.loading.download = false
      }
    },
    async submit() {
      const [file] = this.fileList
      this.loading.submit = true
      try {
        let res
        if (this.type === P)
          res = await ppesp.importProductionPlan(
            { data: file, fileName: file.name },
            this.$route.path[this.$route.path.length - 1]
          )
        if (this.type === M)
          res = await ppesp.importIncomingPlan(
            { data: file, fileName: file.name },
            this.$route.path[this.$route.path.length - 1]
          )

        this.$message.info(
          // `共上传${res.uploadTotal}条数据，成功${res.successUploadRecords}条，失败${res.failUploadRecords}条`
          this.$t('page_upload_info')
            .replace('{0}', res.uploadTotal)
            .replace('{1}', res.successUploadRecords)
            .replace('{2}', res.failUploadRecords)
        )
      } finally {
        this.visible = false
        this.$emit('afterImport')
        this.loading.submit = false
      }
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file]
      return false
    },
    onUploadChange(e) {
      console.log(e)
    },
  },
})
